export const root = '/rankingConfigs'
